var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "with-box-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product-Individual--Desktop",
    transform: "translate(-843.000000, -376.000000)",
    stroke: "#000000",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-filter-4025735",
    transform: "translate(835.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "with-box-icon",
    transform: "translate(9.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6578947,27 L0,27 L0,3 L15.6578947,3 C16.3991395,3 17,3.63204706 17,4.41176471 L17,25.5882353 C17,26.3677647 16.3991395,27 15.6578947,27 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3 L13.2901064,0.0208402689 C13.7312213,-0.051577037 14.1840803,0.0669549206 14.5175163,0.341848001 C14.8509523,0.616921856 15.0276757,1.01772851 14.9964644,1.42825824 L14.9964644,2.99996126",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,25 C22.9707,25 27,20.74666 27,15.5 C27,10.25315 22.97052,6 18,6",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,15 C25.001986,16.0307287 24.6619969,17.0509948 24,18",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,9 C22.3506991,9.5739256 23.4260744,10.6493009 24,12",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,17.3 C18.1045379,17.3 19,16.4045021 19,15.29992 C19,14.1953379 18.1045379,13.3 17,13.3",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,20 C19.2090667,20 21,17.9854 21,15.5 C21,13.0148 19.2090667,11 17,11",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithBoxIcon);
export default __webpack_public_path__ + "static/media/with-box-icon.4c61d147ff9a16a80bf73ece116a584e.svg";
export { ForwardRef as ReactComponent };